import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "hga-theme";
const MODES = ["system", "light", "dark"];

function resolveTheme(mode) {
  if (mode === "system") {
    return window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
  }
  return mode;
}

export function useTheme() {
  const [mode, setMode] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || "system";
    } catch {
      return "system";
    }
  });
  const [resolved, setResolved] = useState(() => resolveTheme(mode));

  useEffect(() => {
    const r = resolveTheme(mode);
    setResolved(r);
    document.documentElement.setAttribute("data-theme", r);
    try {
      localStorage.setItem(STORAGE_KEY, mode);
    } catch {
      // storage unavailable — ignore
    }
  }, [mode]);

  // React to OS theme changes when mode === system
  useEffect(() => {
    if (mode !== "system") return;
    const mq = window.matchMedia("(prefers-color-scheme: light)");
    const handler = () => {
      const r = resolveTheme("system");
      setResolved(r);
      document.documentElement.setAttribute("data-theme", r);
    };
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, [mode]);

  const cycle = useCallback(() => {
    setMode((m) => MODES[(MODES.indexOf(m) + 1) % MODES.length]);
  }, []);

  return { mode, resolved, setMode, cycle };
}
